// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2zGFB","col":"styles_col__3dwOU"};